import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import JobService from "services/jobAd";
import SearchResultsView from "./view";

class SearchResults extends Component {
  state = {
    jobs: [],
    loaded: false,
    value: "",
  };

  componentDidMount() {
    this.getJobs();
  }

  getJobs = () => {
    const { location } = this.props;
    const params = new URLSearchParams(location.search);
    const value = params.get("value");

    this.setState({ value });

    JobService.search(value).then((res) => {
      if (res) this.setState({ jobs: res, loaded: true });
    });
  };

  render() {
    const { jobs, loaded, value } = this.state;
    return <SearchResultsView jobs={jobs} loaded={loaded} value={value} />;
  }
}

export default withRouter(SearchResults);
